<template>
  <Drawer
    class="ls_drawer_main"
    :title="title"
    width="700"
    v-model="showDrawer"
  >
    <!-- ACCOUNT DETAIL -->
    <accountDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></accountDetail>

    <!-- ACCOUNT EDIT/CREATE FORM -->
    <accountForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></accountForm>
  </Drawer>
</template>

<script>
import { BaseItemData } from "../../base/base_item.js";

import accountForm from "@/apps/account/accountForm.vue";
import accountDetail from "@/apps/account/accountDetail.vue";

let _app = BaseItemData();
_app.components = {
  accountForm,
  accountDetail
};
_app.data = function() {
  return {
    titles: {
      detail: "Счет",
      edit: "Редактирование счета",
      create: "Создание счета"
    },
    itemAction: "detail",
    itemId: "",
    showDrawer: false
  };
};
export default _app;
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/account/accountItem.vue